module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Praise for Michael Slade")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent_sp"
  }, [_vm._v("“Michael Slade's books are blood-chilling, spine-tingling, gut-wrenching, stomach-churning, and a much closer look at the inside of a maniac's brain than most people would find comfortable—but always riveting.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(" —Diana Gabaldon,  #1 "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of the Outlander series")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Crime writer Michael Slade is the real deal! As a trial lawyer, Slade knows psycho killers, sex predators, and their horrific crimes inside out. As a Mountie, I worked sex crimes and led a team of ViCLAS psycho-hunters for seven years. If reading Slade makes you react, ‘Wow! Serial killers don't really do that to people, do they?’, I can tell you, yes, they do.”  ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(" —RCMP Staff Sergeant Christine Wozney (ret.), CO of the Violent Crime Linkage Analysis team (West Coast)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Praise for "), _c('i', [_vm._v("Headhunter")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent_sp"
  }, [_vm._v("“"), _c('i', [_vm._v("Headhunter")]), _vm._v(" stunned me. It’s really good.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(" —Alice Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A real chiller! The most gruesome I have ever read.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(" —Robert Bloch, author of "), _c('i', [_vm._v("Psycho")]), _vm._v(", on the original edition of "), _c('i', [_vm._v("Headhunter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“First rate, compelling, nerve-tingling. A novel of sex, death, and the macabre. Extraordinarily vivid. A thinking man’s "), _c('i', [_vm._v("Texas Chainsaw Massacre")]), _vm._v(". It works exceptionally well. One of the novel’s more noteworthy achievements is a complex structure of flashback sequences and parallel story lines, which allows Slade to artfully play the old genre game of posing various solutions to the identity of the killer.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(" —"), _c('i', [_vm._v("The Vancouver Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Full of spooky weird stuff, fast-paced shoot-em-up action, and a surprise ending. There are twists and turns, false leads and sudden shocks. You probably won't be able to figure out whodunit.\" ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(" —"), _c('i', [_vm._v("The Gazette")]), _vm._v(", Montreal")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“WARNING: Not for the squeamish. A novel so terrifying it will haunt your dreams for weeks.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(" —"), _c('i', [_vm._v("Book of the Month Club Magazine")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“An encyclopedia of weirdness. There’s enough assorted kinkiness, perversion, and psychosis in "), _c('i', [_vm._v("Headhunter")]), _vm._v(" to fill a dozen insane asylums. The setting is refreshing, with real suspense and interesting characters.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(" —"), _c('i', [_vm._v("Asbury Park Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1766b593","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise.vue
// module id = 72
// module chunks = 0